<template>
  <table-view
    ref="tableView"
    url="/carphoto/listForPage"
    :filterable="false"
    :filter-form="dataForm"
    :headers="headers"
    show-index
    selectable
    single
  >
    <el-form slot="search" @keyup.enter.native="query" inline>
      <el-form-item label="自编号">
        <el-select
          disabled
          filterable
          placeholder="自编号"
          v-model="dataForm.number"
        >
          <el-option
            v-for="s in carList"
            :key="s.id"
            :label="s.number"
            :value="s.number"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="检测时间">
        <el-date-picker
          clearable
          type="date"
          placeholder="选择开始日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyyMMdd"
          v-model="dataForm.beginDate"
        ></el-date-picker>
        <label>到</label>
        <el-date-picker
          clearable
          type="date"
          placeholder="选择结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyyMMdd"
          v-model="dataForm.endDate"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="检测结果">
        <el-select
          size="mini"
          v-model="dataForm.passed"
          clearable
          filterable
          placeholder="检测结果"
        >
          <el-option
            v-for="item in passedList"
            :key="item.key"
            :label="item.key"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-button @click="query" type="primary">查询</el-button>
    </el-form>
  </table-view>
</template>

<script>
import TableView from "@/components/templates/table-view";
import TableActionColumn from "@/components/templates/table-action-column";

export default {
  name: "car-photo",

  components: { TableView, TableActionColumn },

  data() {
    return {
      headers: [
        { id: 1, prop: "number", label: "自编号" },
        { id: 2, prop: "checkingDate", label: "检测时间" },
        { id: 3, prop: "tdh", label: "信号通道" },
        {
          id: 4,
          prop: "passed",
          label: "检测结果",
          formatter: (row, column, cellValue) => {
            switch (cellValue) {
              case false:
                return "未通过";
              case true:
                return "通过";
            }
          },
        },
      ],
      dataForm: {
        number: "",
        passed: "",
        startDate: "",
        endDate: "",
      },
      passedList: [
        { key: "未通过", value: false },
        { key: "通过", value: true },
      ],
      carList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let data = await this.$http({
        url: this.$http.adornUrl("/car/list"),
        method: "post",
        data: {},
      });
      this.carList = data.datas;
    },
    query() {
      this.$refs.tableView.queryData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item__content {
  .el-date-editor {
    display: inline-block;
    width: 140px;
  }
  label {
    margin: 10px;
  }
}
</style>
